import React, {Component, Fragment} from 'react';
import {Card, CardBody, Col, CustomInput, Form, FormGroup, Row} from 'reactstrap';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import {withTranslation} from 'react-i18next';
import Api from "../../../../services/Api";
import {Form as FinalForm} from "react-final-form";
import LoaderButton from "../../../../components/LoaderButton";
import {NotificationManager} from "../../../../components/common/react-notifications";
import {baseTokenSymbol} from "../../../../constants/configs";
import PriceField from "../../../../components/PriceField";
import Switch from "react-switch";
import {isEqual} from "lodash";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: null,
    };
  }

  componentDidMount() {
    this.fetchPaymentIdSettings();
  }

  fetchPaymentIdSettings = async () => {
    try {
      const {data} = await Api.invoke('GET', '/v2/admin-ui/deposits/paymentIds/settings');
      this.setState({data});
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({loading: false});
    }
  };

  updateSettings = async (values, form) => {
    const {t} = this.props;
    const newValues = {
      enabled: values.enabled,
      autoVerificationMaxAmount: Number(values.autoVerificationMaxAmount),
      feePolicy: {
        type: values.feeType,
        value: Number(values.feeValue),
        threshold: Number(values.feeThreshold),
        maxAmount: values.feeType === 'FIX_BY_THRESHOLD' ? 0 : Number(values.feeMaxAmount),
      }
    };
    try {
      await Api.invoke(
        'PATCH',
        `/v2/admin-ui/deposits/paymentIds/settings`,
        newValues,
      );
      NotificationManager.success(t('Settings updated successfully'), t('Message'));
    } catch (e) {
      setTimeout(form.restart);
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  render() {
    const {t, match} = this.props;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              {this.state.loading ?
                <div className="loading" /> :
                <CardBody>
                  <FinalForm
                    initialValues={{
                      enabled: this.state.data.enabled,
                      feeType: this.state.data.feePolicy.type,
                      feeValue: this.state.data.feePolicy.value,
                      feeMaxAmount: this.state.data.feePolicy.maxAmount,
                      feeThreshold: this.state.data.feePolicy.threshold,
                      autoVerificationMaxAmount: this.state.data.autoVerificationMaxAmount,
                    }}
                    onSubmit={this.updateSettings}
                    render={({form, handleSubmit, submitting, hasValidationErrors, values, initialValues}) => {
                      return (
                        <Form onSubmit={handleSubmit}>
                          <Row className='align-items-center mb-2'>
                            <FormGroup className='d-flex flex-row align-items-center ml-2'>
                              <CustomInput
                                id="1"
                                type="radio"
                                name="customRadio"
                                label={t('Percentage value')}
                                checked={values.feeType === 'PERCENTAGE_BY_THRESHOLD'}
                                onChange={() => {form.change("feeType", "PERCENTAGE_BY_THRESHOLD");}}
                              />
                              <CustomInput
                                type="radio"
                                id="2"
                                className='mx-4'
                                name="customRadio"
                                label={t('Fix value')}
                                checked={values.feeType === 'FIX_BY_THRESHOLD'}
                                onChange={() => {form.change("feeType", "FIX_BY_THRESHOLD");}}
                              />
                            </FormGroup>
                          </Row>
                          <Row className='align-items-center mb-2'>
                            <Col className="col-lg-6 col-md-12">
                              <PriceField
                                item={{
                                  name: 'autoVerificationMaxAmount',
                                  i18n: t('Auto verification max amount') + ` (${t(baseTokenSymbol)})`,
                                  required: true,
                                }}
                              />
                            </Col>
                          </Row>
                          <Row className='align-items-center mb-2'>
                            <Col className="col-lg-6 col-md-12">
                              <PriceField
                                item={{
                                  name: 'feeValue',
                                  i18n: t('Fee value') + ` (${values.feeType === 'FIX_BY_THRESHOLD' ? t(baseTokenSymbol) : t('Percentage')})`,
                                  required: true,
                                }}
                              />
                            </Col>
                          </Row>
                          {values.feeType === 'PERCENTAGE_BY_THRESHOLD' &&
                            <Row className='align-items-center mb-2'>
                              <Col className="col-lg-6 col-md-12">
                                <PriceField
                                  item={{
                                    name: 'feeMaxAmount',
                                    i18n: t('Fee max amount') + ` (${t(baseTokenSymbol)})`,
                                    required: true,
                                  }}
                                />
                              </Col>
                            </Row>
                          }
                          <Row className='align-items-center mb-3'>
                            <Col className="col-lg-6 col-md-12">
                              <PriceField
                                item={{
                                  name: 'feeThreshold',
                                  i18n: t('Fee threshold') + ` (${t(baseTokenSymbol)})`,
                                  required: true,
                                }}
                              />
                            </Col>
                          </Row>
                          <Row className='align-items-center mb-2'>
                            <Switch
                              className="mx-3 ltr"
                              onChange={enabled => {form.change('enabled', enabled);}}
                              checked={values.enabled}
                              height={24}
                              width={45}
                            />
                            <span className={`mx-2 ${values.enabled ? 'text-success' : 'text-danger'}`}>
                              {t('Status')} {values.enabled ? t('Enabled') : t('Disabled')}
                            </span>
                          </Row>
                          <Row className='mt-5'>
                            <Col>
                              <LoaderButton
                                color="success"
                                className="text-center"
                                loading={submitting}
                                onClick={handleSubmit}
                                style={{minWidth: '100px'}}
                                disabled={hasValidationErrors || submitting || isEqual(values, initialValues)}>
                                {t('Update')}
                              </LoaderButton>
                            </Col>
                          </Row>
                        </Form>
                      );
                    }}
                  />
                </CardBody>
              }
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
